var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar',{attrs:{"src":_vm.thumbnail,"icon":"people-fill","square":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }